(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenach-hero"] && !Shopify.designMode) return;
  try {
    
  class ZenachHeroCarousel extends HTMLElement {
    #observer;
    #controller;
    #slideshow;
    async connectedCallback() {
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      const syncFocus = () => {
        this.querySelectorAll('slideshow-slide').forEach(slide => {
          slide.inert = slide.getAttribute('aria-hidden') === 'true';
        });
      };
      syncFocus();
      this.#observer = new MutationObserver(syncFocus);
      this.#observer.observe(this, { subtree:true, attributes:true, attributeFilter:['aria-hidden'], childList:true });
      await customElements.whenDefined('slideshow-component');
      if (signal.aborted || !this.isConnected) return;
      this.#slideshow = this.querySelector('slideshow-component');
      const slideshow = this.#slideshow;
      if (!slideshow) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (motion.matches) slideshow.pause();
      motion.addEventListener('change', event => {
        if (event.matches) slideshow.pause();
      }, { signal });
      this.addEventListener('focusin', () => slideshow.pause(), { signal });
      const syncLive = () => slideshow.setAttribute('aria-live', slideshow.paused ? 'polite' : 'off');
      syncLive();
      this.#observer.disconnect();
      this.#observer = new MutationObserver(() => { syncFocus(); syncLive(); });
      this.#observer.observe(this, { subtree:true, attributes:true, attributeFilter:['aria-hidden','paused'], childList:true });
    }
    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#controller?.abort();
      this.#slideshow?.pause();
    }
  }
  if (!customElements.get('zenach-hero-carousel')) {
    customElements.define('zenach-hero-carousel', ZenachHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
